export default {"src":"/_next/static/media/alert.39ff9906.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};